import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const MatrixContainer = styled.div`
  display: inline-block;
  width: 1100px;
  @media (max-width: 1300px) {
    width: 60%;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 80%;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 90%;
  }
`

export const Section = styled.div`
  text-align: center;
  padding: 130px 0px;
  background-color: #dbe9f2;
  @media (max-width: ${breakpoints.l}px) {
    padding: 80px 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    padding: 60px 0px;
  }
`
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  gap: 10px;
  max-width: 1200px;
  margin: auto;
  padding: 50px;
`
export const ImageContainer = styled.div`
  width: ${(props) => props.width || '100%'};
  margin: auto;
`
export const Icon = styled.div`
  width: 30px;
`
export const FeatureItem = styled.div`
  border-radius: 16px;
  background: #fff;
  @media (max-width: 390px) {
    border-radius: 14px;
  }
`
export const Row = styled.tr`
  background: ${(props) => (props.white ? '#fff' : props.last ? '#dbe9f2' : '#F2F2F2')};
`

export const Cell = styled.td`
  padding: 16px 20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  @media (max-width: ${breakpoints.s}px) {
    padding: 22px 0px 22px 16px;
  }
`
export const CheckCell = styled.td`
  padding: 16px 0px;
  border-left: ${(props) => (props.blue ? '3px solid #dbe9f2' : 'none')};
  border-right: ${(props) => (props.blue ? '3px solid #dbe9f2' : 'none')};
  border-top-right-radius: ${(props) => (props.borderRadius ? '16px' : '0px')};
  border-bottom-right-radius: ${(props) => (props.borderRadius ? '16px' : '0px')};
  @media (max-width: ${breakpoints.s}px) {
    border-left: none;
  }
`
export const HeaderCell = styled.th``
export const HeaderCellText = styled.th`
  font-size: 20px;
  font-family: 'FilsonPro';
  width: 120px;
  line-height: 18px;
  vertical-align: bottom;
  @media (max-width: ${breakpoints.m}px) {
    width: 90px;
  }
  @media (max-width: ${breakpoints.s}px) {
    width: 70px;
  }
  @media (max-width: 390px) {
    width: 50px;
  }
`

export const Title = styled.h2`
  color: black;
  font-size: 20px;
  line-height: 24px;
  font-family: 'FilsonPro';
  @media (max-width: ${breakpoints.m}px) {
    font-size: 18px;
    line-height: 18px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    line-height: 18px;
  }
  @media (max-width: 390px) {
    font-size: 13px;
  }
`
export const Subheader = styled.p`
  font-family: 'FilsonPro';
  font-size: 40px;
  margin: 0px;
  text-align: left;
  color: black;
  margin-bottom: -50px;
  margin-left: -36px;
  @media (max-width: ${breakpoints.l}px) {
    margin-bottom: 0px;
    font-size: 32px;
    margin-bottom: -8px;
    margin-left: 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 24px;
    text-align: center;
    margin-bottom: 8px;
  }
`
export const Checkmark = styled.div`
  align-self: center;
  width: 30px;
  margin: auto;
  @media (max-width: ${breakpoints.m}px) {
    width: 20px;
  }
`
export const FeatureName = styled.p`
  color: black;
  font-size: 18px;
  line-height: 36px;
  margin: 0px;
  text-align: left;
  @media (max-width: 1350px) {
    font-size: 16px;
    line-height: 22px;
  }
  @media (max-width: 400px) {
    font-size: 15px;
  }
  @media (max-width: 350px) {
    font-size: 13px;
  }
`

export const FeatureDetail = styled(FeatureName)`
  font-size: 16px;
  font-family: 'FilsonProRegularItalic';
  margin-top: -10px;
  line-height: 140%;
  color: ${(props) => props.theme.grayDark};
  @media (max-width: 1350px) {
    font-size: 13px;
    margin-top: 0px;
  }
`
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`
